import React from 'react';

/**
 * Card — the base surface. slate-800 fill, subtle border, 16px radius, soft shadow.
 * Adapts to light theme via tokens. `interactive` adds hover lift.
 */
export function Card({ interactive = false, padding = 'var(--pad-card)', children, style = {}, ...rest }) {
  const [hover, setHover] = React.useState(false);
  return (
    <div
      onMouseEnter={() => interactive && setHover(true)}
      onMouseLeave={() => interactive && setHover(false)}
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: hover ? 'var(--shadow-raised)' : 'var(--shadow-card)',
        padding,
        color: 'var(--text-body)',
        fontFamily: 'var(--font-sans)',
        transform: hover ? 'translateY(-2px)' : 'none',
        transition: 'transform .18s ease, box-shadow .18s ease',
        cursor: interactive ? 'pointer' : 'default',
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
